import axiosConfig from './axiosConfig';

export const expenseApi = {
  getAll: async (params = {}) => {
    const response = await axiosConfig.get('/expenses', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axiosConfig.get(`/expenses/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axiosConfig.post('/expenses', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosConfig.put(`/expenses/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosConfig.delete(`/expenses/${id}`);
    return response.data;
  },

  validate: async (id) => {
    const response = await axiosConfig.patch(`/expenses/${id}/validate`);
    return response.data;
  },
};
